import React from 'react';
import Responsive from 'react-responsive';

export const BREAKPOINTS = {
  desktop: 801,
};

export const OnMobile = props => <Responsive {...props} maxWidth={BREAKPOINTS.desktop - 1} />;
export const OnDesktop = props => <Responsive {...props} minWidth={BREAKPOINTS.desktop} />;
